import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Legal Info",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      { fieldName: "hotelTicker", displayName: "Hotel Ticker" },
      { fieldName: "property", displayName: "Policy Type" },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      { fieldName: "id" },
      { fieldName: "hotelTicker", displayName: "Hotel Ticker" },
      {
        fieldName: "property",
        displayName: "Policy Type",
        optionDisplay: {
          PRIVACY_POLICY: { label: "Privacy Policty" },
          COMMUNICATIONS_POLICY: { label: "Communication Policy" },
        },
        helpText:
          "Privacy Policy: Text which indicates compliance with LOPD and GDPR</br>" +
          "Communication Policy: Text the user will read in order to accept receiving offers and promotions through email",
      },
      { fieldName: "text", displayName: "Texto" },
    ],
  },
};
